/*
  Madison Center: "Favoritos" (corazón de la ficha del producto y lista en Mi cuenta). Pedido de Jonathan 2026-10-05.
  Lista APARTE de "Guardar para después".
  - Cliente con sesión: la lista vive en su cuenta, en el servidor guardados-madison (/apps/guardados/favoritos/...,
    firmado por Shopify). Lo que había marcado en este navegador antes de iniciar sesión se une a su cuenta.
  - Sin sesión: se guarda en este navegador (localStorage "madison.favoritos").
  Solo se guarda: número de variante, handle del producto y fecha. Lo usan snippets/madison-ficha-movil.liquid y
  sections/main-customers-account.liquid con window.MadisonFavoritos.
*/
(function () {
  if (window.MadisonFavoritos) return;
  var API = '/apps/guardados/favoritos';
  var LOCAL = 'madison.favoritos';
  var cache = null;

  function conSesion() {
    var cuenta = document.querySelector('.header__account-icon');
    return !!(cuenta && /\/account\/?$/.test(cuenta.getAttribute('href') || ''));
  }
  function leerLocal() {
    try { var l = JSON.parse(localStorage.getItem(LOCAL) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function escribirLocal(lista) {
    try { localStorage.setItem(LOCAL, JSON.stringify(lista.slice(0, 100))); } catch (e) {}
  }
  function llamar(ruta, datos) {
    return fetch(API + '/' + ruta, {
      method: datos ? 'POST' : 'GET',
      headers: datos ? { 'Content-Type': 'application/json' } : {},
      body: datos ? JSON.stringify(datos) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      var tipo = r.headers.get('Content-Type') || '';
      if (!r.ok || tipo.indexOf('json') < 0) throw new Error('servidor ' + r.status);
      return r.json();
    }).then(function (json) {
      if (!Array.isArray(json.productos)) throw new Error('respuesta');
      return json.productos;
    });
  }

  // La lista actual (con sesión: la de su cuenta, uniendo lo que había en este navegador)
  function lista() {
    if (cache) return cache;
    var local = leerLocal();
    if (!conSesion()) { cache = Promise.resolve(local); return cache; }
    cache = (local.length ? llamar('unir', { productos: local }) : llamar('lista'))
      .then(function (productos) { if (local.length) escribirLocal([]); return productos; })
      .catch(function () { return local; });
    return cache;
  }

  // Nombre y foto del producto: se guardan con el favorito para mostrarlo en gris si luego se agota y sale de la web
  // (los agotados se sacan del canal Tienda online). Jonathan 2026-10-12. Si no se pueden leer, se guarda sin ellos.
  function fichaDe(producto) {
    return fetch('/products/' + encodeURIComponent(producto) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { return p ? { titulo: p.title, imagen: p.featured_image || '' } : {}; })
      .catch(function () { return {}; });
  }

  function agregar(variante, producto) {
    var item = { variante: String(variante), producto: producto, cantidad: 1, fecha: new Date().toISOString() };
    return fichaDe(producto).then(function (ficha) {
      if (ficha.titulo) item.titulo = ficha.titulo;
      if (ficha.imagen) item.imagen = ficha.imagen;
      return lista();
    }).then(function (actual) {
      var nueva = [item].concat(actual.filter(function (p) { return p.producto !== producto; }));
      if (!conSesion()) { escribirLocal(nueva); cache = Promise.resolve(nueva); return nueva; }
      cache = llamar('guardar', item).catch(function () { escribirLocal(nueva); return nueva; });
      return cache;
    });
  }

  function quitar(producto) {
    return lista().then(function (actual) {
      var fuera = actual.filter(function (p) { return p.producto === producto; });
      var nueva = actual.filter(function (p) { return p.producto !== producto; });
      if (!conSesion()) { escribirLocal(nueva); cache = Promise.resolve(nueva); return nueva; }
      cache = fuera.reduce(function (promesa, p) {
        return promesa.then(function () { return llamar('quitar', { variante: p.variante }); });
      }, Promise.resolve(nueva)).catch(function () { return nueva; });
      return cache;
    });
  }

  function tiene(producto) {
    return lista().then(function (l) { return l.some(function (p) { return p.producto === producto; }); });
  }

  // Aviso abajo de la pantalla
  var temporizador;
  function aviso(texto) {
    var el = document.querySelector('.madison-fav-aviso');
    if (!el) {
      el = document.createElement('div');
      el.className = 'madison-fav-aviso';
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:16px;right:16px;bottom:96px;z-index:2147483000;display:flex;align-items:center;gap:10px;' +
        'padding:14px 16px;border-radius:14px;background:#1F2547;color:#fff;font-size:15px;line-height:1.3;box-shadow:0 8px 24px rgba(0,0,0,.25);' +
        'opacity:0;transform:translateY(16px);transition:opacity .2s,transform .2s;pointer-events:none;max-width:480px;margin:0 auto;';
      document.body.appendChild(el);
    }
    el.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" style="flex:0 0 22px"><path d="M12 21s-7.5-4.6-9.6-9.3C.9 8.3 3 4.5 6.7 4.5c2.2 0 3.6 1.2 5.3 3.1 1.7-1.9 3.1-3.1 5.3-3.1 3.7 0 5.8 3.8 4.3 7.2C19.5 16.4 12 21 12 21z" fill="#6C8CFF"/></svg><span></span>';
    el.querySelector('span').textContent = texto;
    requestAnimationFrame(function () { el.style.opacity = '1'; el.style.transform = 'translateY(0)'; });
    clearTimeout(temporizador);
    temporizador = setTimeout(function () { el.style.opacity = '0'; el.style.transform = 'translateY(16px)'; }, 2600);
  }

  window.MadisonFavoritos = { lista: lista, agregar: agregar, quitar: quitar, tiene: tiene, aviso: aviso, conSesion: conSesion };

  // Corazón en las TARJETAS de producto (categorías, filas desplegadas, lista y cuadrícula, sugeridos, vistos y búsqueda).
  // Pedido de Jonathan 2026-10-07. Chico y ABAJO a la derecha de la foto (arriba chocaba con etiquetas x5/x6 de las fotos);
  // azul si ya está en Favoritos. No va en la tarjeta "Ver Más".
  var CORAZON = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.5s-7.6-4.6-9.5-9.2C1 7.8 3.1 4.5 6.6 4.5c2.2 0 3.7 1.3 5.4 3.2 1.7-1.9 3.2-3.2 5.4-3.2 3.5 0 5.6 3.3 4.1 6.8-1.9 4.6-9.5 9.2-9.5 9.2z"/></svg>';
  var estilo = document.createElement('style');
  estilo.textContent =
    '.madison-corazon{position:absolute;bottom:4px;right:4px;z-index:3;display:flex;align-items:center;justify-content:center;width:28px;height:28px;padding:0;' +
    'border:0;border-radius:50%;background:rgba(255,255,255,.92);box-shadow:0 1px 4px rgba(0,0,0,.15);cursor:pointer}' +
    '.madison-corazon svg{width:16px;height:16px;fill:none;stroke:#1C1B1B;stroke-width:1.8}' +
    '.madison-corazon.on svg{fill:#37439B;stroke:#37439B}' +
    '.madison-ver-todo .madison-corazon{display:none!important}' +
    // Filas cerradas (fotos pequeñas): todavía más chico
    '.block-list--collapsed .madison-corazon{bottom:2px;right:2px;width:22px;height:22px}' +
    '.block-list--collapsed .madison-corazon svg{width:13px;height:13px}';
  document.head.appendChild(estilo);

  var marcados = null;
  function recargarMarcados() {
    return lista().then(function (l) { marcados = {}; l.forEach(function (p) { marcados[p.producto] = true; }); pintar(); });
  }
  function datosTarjeta(tarjeta) {
    var enlace = tarjeta.querySelector('a[href*="/products/"]');
    var handle = tarjeta.getAttribute('data-handle') || (enlace && (enlace.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1]);
    var campo = tarjeta.querySelector('input[name="id"], [data-variant-id], [data-product-variant-id]');
    var variante = tarjeta.getAttribute('data-variant-id') || (campo && (campo.value || campo.getAttribute('data-variant-id') || campo.getAttribute('data-product-variant-id')));
    return { handle: handle, variante: variante, foto: enlace };
  }
  function pintar() {
    if (!marcados) return;
    Array.prototype.forEach.call(document.querySelectorAll('.madison-corazon'), function (b) {
      b.classList.toggle('on', !!marcados[b.getAttribute('data-handle')]);
      b.setAttribute('aria-pressed', marcados[b.getAttribute('data-handle')] ? 'true' : 'false');
    });
  }
  function ponerCorazones() {
    // .product-item = tarjetas del tema; .ais-hit = tarjetas del buscador (Algolia), con data-handle y data-variant-id
    Array.prototype.forEach.call(document.querySelectorAll('.product-item:not(.madison-ver-todo), .ais-hit.ais-product'), function (tarjeta) {
      if (tarjeta.querySelector('.madison-corazon')) return;
      var d = datosTarjeta(tarjeta);
      if (!d.handle) return;
      var foto = tarjeta.classList.contains('ais-hit') ? tarjeta : (tarjeta.querySelector('.product-item__image-wrapper') || d.foto);
      if (!foto) return;
      if (getComputedStyle(foto).position === 'static') foto.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'madison-corazon';
      b.setAttribute('aria-label', 'Agregar a Favoritos');
      b.setAttribute('data-handle', d.handle);
      if (d.variante) b.setAttribute('data-variante', d.variante);
      b.innerHTML = CORAZON;
      foto.appendChild(b);
    });
    ajustarBuscador();
    pintar();
  }
  // En el buscador la foto no tiene caja propia: se calcula dónde termina la foto para poner el corazón en su esquina de abajo
  function ajustarBuscador() {
    Array.prototype.forEach.call(document.querySelectorAll('.ais-hit .madison-corazon'), function (b) {
      var img = b.parentNode.querySelector('img');
      if (!img || !img.offsetHeight) return;
      b.style.bottom = 'auto';
      b.style.top = (img.offsetTop + img.offsetHeight - b.offsetHeight - 4) + 'px';
      b.style.right = Math.max(4, b.parentNode.clientWidth - img.offsetLeft - img.offsetWidth + 4) + 'px';
      if (!img.complete && !img.madisonEspera) { img.madisonEspera = true; img.addEventListener('load', ajustarBuscador); }
    });
  }
  window.addEventListener('resize', ajustarBuscador);
  window.addEventListener('load', ajustarBuscador);
  function varianteDe(b) {
    var v = b.getAttribute('data-variante');
    if (v) return Promise.resolve(v);
    return fetch('/products/' + b.getAttribute('data-handle') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) { var vv = (p.variants.filter(function (x) { return x.available; })[0] || p.variants[0]); return String(vv.id); });
  }
  // En captura, para que el toque no abra la ficha (el corazón está dentro del enlace de la foto)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.madison-corazon');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = b.getAttribute('data-handle');
    var esta = marcados && marcados[handle];
    if (!marcados) marcados = {};
    marcados[handle] = !esta;
    pintar();
    (esta ? quitar(handle) : varianteDe(b).then(function (v) { return agregar(v, handle); }))
      .then(function () {
        aviso(esta ? 'Se quitó este producto de tus favoritos' : 'Se ha agregado este producto a tus favoritos');
        document.dispatchEvent(new CustomEvent('madison:favoritos'));
      })
      .catch(function () { marcados[handle] = esta; pintar(); aviso('No se pudo guardar. Intenta de nuevo.'); });
  }, true);
  document.addEventListener('madison:favoritos', function () { cache = null; recargarMarcados(); });

  function iniciarCorazones() {
    ponerCorazones();
    recargarMarcados();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(ponerCorazones, 120); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarCorazones); else iniciarCorazones();
})();
